import React from 'react';

function Pencil(props: object) {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.17551 1.95939L1.70218 7.75272C1.49551 7.97272 1.29551 8.40606 1.25551 8.70606L1.00885 10.8661C0.92218 11.6461 1.48218 12.1794 2.25551 12.0461L4.40218 11.6794C4.70218 11.6261 5.12218 11.4061 5.32885 11.1794L10.8022 5.38606C11.7488 4.38606 12.1755 3.24606 10.7022 1.85272C9.23551 0.472723 8.12218 0.959389 7.17551 1.95939Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.26172 2.92578C6.54839 4.76578 8.04172 6.17245 9.89505 6.35911"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Pencil;
